import { Apple, Play } from "lucide-react";

export default function StoreButtons({ idPrefix = "", surface = "dark" }) {
  const hover =
    surface === "green"
      ? {
          play: "hover:border-black/60 hover:shadow-[0_12px_40px_rgba(0,0,0,0.45)]",
          apple: "hover:border-brand-yellow hover:shadow-[0_0_35px_rgba(255,204,0,0.45)]",
        }
      : {
          play: "hover:border-brand-green hover:shadow-[0_0_35px_rgba(0,200,83,0.35)]",
          apple: "hover:border-brand-yellow hover:shadow-[0_0_35px_rgba(255,204,0,0.35)]",
        };

  const base =
    "inline-flex flex-1 sm:flex-none items-center justify-start gap-2.5 sm:gap-3 rounded-xl sm:rounded-2xl bg-black text-white px-4 sm:px-6 py-3 sm:py-3.5 border border-white/15 hover:scale-105 transition-all duration-300";

  const tid = (name) => (idPrefix ? `${idPrefix}-${name}` : name);

  return (
    <div className="flex flex-row flex-wrap gap-3 sm:gap-4 w-full sm:w-auto">
      <a
        href="#google-play"
        data-testid={tid("google-play-button")}
        aria-label="Get it on Google Play"
        className={`${base} ${hover.play}`}
      >
        <Play className="w-6 h-6 sm:w-7 sm:h-7 fill-white shrink-0" />
        <span className="text-left leading-tight">
          <span className="block text-[9px] sm:text-[10px] font-semibold uppercase tracking-widest text-zinc-400">
            Get it on
          </span>
          <span className="block font-display font-semibold text-base sm:text-lg whitespace-nowrap">Google Play</span>
        </span>
      </a>
      <a
        href="#app-store"
        data-testid={tid("app-store-button")}
        aria-label="Download on the App Store"
        className={`${base} ${hover.apple}`}
      >
        <Apple className="w-6 h-6 sm:w-8 sm:h-8 shrink-0" />
        <span className="text-left leading-tight">
          <span className="block text-[9px] sm:text-[10px] font-semibold uppercase tracking-widest text-zinc-400">
            Download on the
          </span>
          <span className="block font-display font-semibold text-base sm:text-lg whitespace-nowrap">App Store</span>
        </span>
      </a>
    </div>
  );
}
